<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import { ControlsContainer, Text } from '@Shelly/shelly-design-system';
	//Component
	import DirectionButton from './DirectionButton.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device, statuses: VCInterfaceStatus[];
</script>

<ControlsContainer class="mb-xs">
	<svelte:fragment slot="first">
		<DirectionButton deviceButtonV2Props={{ size: 'l' }} direction="open" {device} {statuses} />
		<Text styleType="controls-large" class="mt-s text-bold"
			>{$format('text_device_control_direction_open', {
				default: 'Open',
			})}</Text
		>
	</svelte:fragment>
	<svelte:fragment slot="second">
		<DirectionButton deviceButtonV2Props={{ size: 'l' }} direction="close" {device} {statuses} />
		<Text styleType="controls-large" class="mt-s text-bold"
			>{$format('text_device_control_direction_close', {
				default: 'Close',
			})}</Text
		>
	</svelte:fragment>
</ControlsContainer>
